module.exports = __webpack_public_path__ + "static/assets/b64bf592538d84c6b6d45ed92ef4a6c6.png";